import styled from "styled-components";
import {useSelector} from "react-redux";
import {GET_PAYMENT_METHOD} from "@/store/slices/paymentSlice";
import themes from "@/styles/themes";
import {mdiCheck} from "@mdi/js";
import Icon from "@mdi/react";
import { ReactNode } from "react";

const BorderDiv = styled.div`
  border: 1px solid #999;
  border-radius: 4px;
  margin: 0 0 15px 0;
  &.active{
    border-color: ${themes.estadao};
  }
  div.children-payment {
    padding: 0 15px 10px 15px;
  }
  svg{
    width: 40px;
    margin-left: 2px;
  }
`

const ButtonStyle = styled.button`
  width: 100%;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 16px;
  color: ${themes.estadao};
  position: relative;
  text-align: left;
  padding: 10px 15px;
  background: none;
  display: flex;
  align-items: center;
  height: 50px;

  &:hover {
    .input-group input ~ .checkmark {
      background-color: #fff;
    }
  }

  .input-group {
    display: block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 14px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }


  .input-group input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 18px;
    width: 18px;
    background-color: ${themes.white};
    border: 1px solid ${themes.estadao};
    border-radius: 50%;
  }

  /* When the radio button is checked, add a blue background */

  .input-group input:checked ~ .checkmark {
    background-color: white;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */

  .input-group input:checked ~ .checkmark:after {
    display: block;
  }

  .input-group .checkmark:after {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${themes.estadao};
  }
`
const Check = styled.div`
  flex-grow: 1;
  justify-content: end;
  width: auto;
  display: flex;

  svg {
    color: ${themes.green};
  }
`

interface IButtonPaymentsProps{
  forma: string
  label: string
  onClick: () => void
  children: ReactNode
}

export default function ButtonPayments(props: IButtonPaymentsProps) {
    const {forma, onClick, label} = props
    const payment_method = useSelector(GET_PAYMENT_METHOD)
    return (
        <BorderDiv className={payment_method === forma ? 'active' :  ''}>
            <ButtonStyle onClick={onClick}>
                <div className={'input-group'}>
                    <input type={'radio'} checked={forma === payment_method} readOnly={true} />
                    <span className={'checkmark'}></span>
                </div>
                <span style={{fontWeight: 600}}>{label}</span>
                {payment_method === forma && <Check> <Icon path={mdiCheck} size={1}></Icon></Check>}
            </ButtonStyle>
            {payment_method === forma && <div className={'children-payment'}>{props.children}</div>}
        </BorderDiv>

    )
}